import isEqual from 'lodash/isEqual';
import { type TopProps, type WidgetInternalProps } from '../../../types/WidgetProps';

/**
 * Comparing objects and primitives (not functions) using deep equal
 * to trigger changes in main store.
 */
export const areComparablePropsChanged = (prevProps: WidgetInternalProps, curProps: WidgetInternalProps) => {
  const {
    onPaymentAuthorized,
    onCancel,
    onClick,
    onPaymentAuthorizedInit,
    onPaymentMethodsAmountInit,
    onShippingContactSelected,
    onShippingMethodSelected,
    getInitialPaymentData,
    fedopsLoggerFactory,
    revalidateAppInstance,
    ...comparableTopProps
  } = extractTopProps(curProps);

  const {
    onPaymentAuthorized: _,
    onCancel: __,
    onClick: ___,
    onPaymentAuthorizedInit: ____,
    onPaymentMethodsAmountInit: _____,
    onShippingContactSelected: ______,
    onShippingMethodSelected: _______,
    getInitialPaymentData: ________,
    fedopsLoggerFactory: _________,
    revalidateAppInstance: __________,
    ...comparableTopPropsPrev
  } = extractTopProps(prevProps);

  return !isEqual(comparableTopProps, comparableTopPropsPrev);
};

export const extractTopProps = (props: WidgetInternalProps): TopProps => {
  const { widgetSettings, fedopsLogger, biLoggerFactory, preloadingData, ...topProps } = props;
  return topProps;
};
